import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ColorPaletteService
       } from 'app/controls/color-chooser/color-palette.service';
import { ControlsModule } from 'app/controls/controls.module';
import { GalleryModule } from 'app/gallery/gallery.module';
import { ImageSelectionDirectiveModule } from 'app/image-selection.directive';
import { ProgressModule } from 'app/progress/progress.module';
import { ToolboxService } from 'app/toolboxes/toolbox.service';
import { ToolboxesModule } from 'app/toolboxes/toolboxes.module';
import { AdditionalInfoItemsComponent
       } from 'collage-designer/additional-info-items.component';
import { ConfigService } from 'core/config/config.service';
import { MatModule } from 'core/material/mat.module';
import { PipesModule } from 'core/pipes/pipes.module';
import { StageModule } from '../stage/stage.module';
import { DesignStepComponent } from './design-step.component';
import { DesignStepService } from './design-step.service';

import { PriceModule } from 'core/price/price.module';
import { TranslationModule } from 'core/translation/translation.module';

@NgModule({
  imports: [
    CommonModule,
    ControlsModule,
    FormsModule,
    ProgressModule,
    GalleryModule,
    MatModule,
    PipesModule,
    PriceModule,
    ToolboxesModule,
    TranslationModule,
    StageModule,
    ImageSelectionDirectiveModule,
  ],
  declarations: [
    DesignStepComponent,
    AdditionalInfoItemsComponent,
  ],
  exports: [
    DesignStepComponent,
  ],
  providers: [
    ConfigService,
    ColorPaletteService,
    DesignStepService,
    ToolboxService,
  ]
})
export class DesignStepModule { }



// WEBPACK FOOTER //
// ./src/app/collage-designer/design-step/design-step.module.ts